module.exports = __webpack_public_path__ + "img/BANDEAU_FILTRE_DESACTIVE.cc79de34.svg";